import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
import { HeroSocialProof } from './HeroSocialProof';
import { BUY_URL, PRODUCT_IMAGE } from '../data/content';
const BADGES = [{
  emoji: '📄',
  label: '100% PDF'
}, {
  emoji: '⚡️',
  label: 'Entrega Inmediata'
}, {
  emoji: '📚',
  label: '7 Módulos + 5 Bonos'
}];
export function Hero() {
  return <section className="relative px-5 pt-10 pb-8" data-id="element-123" data-mp="128frdnreylxt">
      <div className="mx-auto max-w-md" data-id="element-124" data-mp="1274p5sdm9m8t">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mx-auto max-w-[25rem] text-center font-anton text-[2rem] leading-[1.02] text-white sm:max-w-md sm:text-[2.5rem]" data-id="element-125" data-mp="xa4ibf8y0fgn">
          Programa{' '}
          <span className="text-[#F5C518]" data-id="element-126" data-mp="381e25e7i07uk">3 meses de clases HYROX</span> en
          una tarde, no cada domingo por la noche.
        </motion.h1>

        <motion.a href={BUY_URL} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mx-auto mt-6 block w-4/5 overflow-hidden rounded-2xl border border-white/10 bg-black/40 shadow-2xl" data-id="element-127" data-mp="3j6obvk13emq3">
          <img src={PRODUCT_IMAGE} alt="HYROX Definitivo 360 — Edición Coach: guía completa para entrenadores de HYROX" className="w-full" data-id="element-128" data-mp="35aud3tu19dqp" />
        </motion.a>

        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mx-auto mt-5 max-w-sm text-center text-sm leading-snug text-neutral-300 sm:text-base" data-id="element-129" data-mp="2vgu25bc2lea2">
          El sistema completo para programar tus clases de HYROX, prevenir
          lesiones en tus alumnos y hacer crecer tu negocio, sin tener que
          improvisar cada semana.
        </motion.p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5" data-id="element-130" data-mp="deq4e3a3ghwp">
          {BADGES.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-[#F5C518]/40 bg-[#F5C518]/10 px-3 py-1.5 text-sm font-600 text-white" data-id="element-131" data-mp="1ayt710s27lbf">
              <span aria-hidden="true" data-id="element-132" data-mp="x14pa1tagual">{b.emoji}</span>
              {b.label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-133" data-mp="3ltgnrsgieupe">
          <BuyButton data-id="element-134" data-mp="3luia4t2z73mf" />
          <HeroSocialProof data-id="element-135" data-mp="3lqugltxj6h7p" />
        </div>
      </div>
    </section>;
}